export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-magnifying-glass-7aeb9349f111edaa0955bcd104a8e824.svg";